import React from "react";
import "./css/Invitation.css"
import bride from "../assets/img/bride.jpg"
import groom from "../assets/img/groom.jpg"

export default function Invitation(){

    return (
        <section id="invitation" className="pt-4 section-padding section-bg" data-aos="fade-down" data-aos-delay="100">
            <div className="container invitation-container">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <h1 className="handwriting">Hello!</h1>
                        <p className="invited">You're Invited To Our Wedding</p>
                        <p className="invited">On</p>
                        <p className="invite-date">Saturday, March 6<sup>th</sup> 2021</p>
                        <br/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-1">
                    </div>
                    <div className="col-lg-4 groom mb-3 mt-3 text-center">
                        <div className="text-center">
                            <img className="rounded-circle groom-image" alt={groom} src={groom}/>
                        </div>
                        <h2 className="groomname mt-3">Rijal<br className="d-none d-lg-block col-md-12"/>&nbsp;Permana</h2>
                        <p className="groom-parents">1<sup>st</sup> Son of Bapak Ahmad Jeje <br/>&amp;<br/> Ibu Supriatin</p>
                    </div>
                    <div className="col-lg-2 ampersand text-center">
                        <h1 className="main-text-invitation"><b>&amp;</b></h1>
                    </div>
                    <div className="col-lg-4 bride mb-3 mt-3 text-center">
                        <div className="text-center">
                            <img className="rounded-circle bride-image" alt={bride} src={bride}/>
                        </div>
                        <h2 className="bridename mt-3">Sani Asmi<br className="d-none d-lg-block col-md-12"/>&nbsp;Ramdani Lestari</h2>
                        <p className="bride-parents">2<sup>nd</sup> Daughter of Bapak Asep Jihad <br/>&amp;<br/> Ibu Mimin Azminatus Sa'diyah</p>
                    </div>
                    <div className="col-lg-1">
                    </div>
                </div>
            </div>
        </section>
    )
}